module.exports = __webpack_public_path__ + "static/media/bg2.2c82f6d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/editor/layout/addons/props/components/bgTheme/bg/bg2.jpg
// module id = 3323
// module chunks = 0